export default __webpack_public_path__ + "static/media/join.0575d651.svg";